import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.GetWxaSessionReq, b: any) => Promise<wechat.GetWxaSessionRes>} TypeScript syntax */

export function GetWxaSession(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSession",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.GetWxaUserInfoReq, b: any) => Promise<wechat.GetWxaUserInfoRes>} TypeScript syntax */

export function GetWxaUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaUserInfo",
    "auth": "1"
  }), o));
}
;
/** @type {(r: wechat.GetWxaPhoneNumberReq, b: any) => Promise<wechat.GetWxaPhoneNumberRes>} TypeScript syntax */

export function GetWxaPhoneNumber(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaPhoneNumber",
    "auth": "1"
  }), o));
}
;
/** @type {(r: wechat.EncodeWxaSceneReq, b: any) => Promise<wechat.EncodeWxaSceneRes>} TypeScript syntax */

export function EncodeWxaScene(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/EncodeWxaScene",
    "auth": "1"
  }), o));
}
;
/** @type {(r: wechat.DecodeWxaSceneReq, b: any) => Promise<wechat.DecodeWxaSceneRes>} TypeScript syntax */

export function DecodeWxaScene(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/DecodeWxaScene",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.GetWxaCodeUnlimitReq, b: any) => Promise<wechat.GetWxaCodeUnlimitRes>} TypeScript syntax */

export function GetWxaCodeUnlimit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaCodeUnlimit",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.CreateWxaQrcodeReq, b: any) => Promise<wechat.CreateWxaQrcodeRsp>} TypeScript syntax */

export function CreateWxaQrcode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/CreateWxaQrcode",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.AddWxaFormIdReq, b: any) => Promise<wechat.AddWxaFormIdRes>} TypeScript syntax */

export function AddWxaFormId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AddWxaFormId",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.DecodeEncryptedDataReq, b: any) => Promise<wechat.DecodeEncryptedDataRes>} TypeScript syntax */

export function DecodeEncryptedData(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/DecodeEncryptedData",
    "auth": "1"
  }), o));
}
; // @error:
// ErrNotFoundFormId
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.SendWxaTemplateReq, b: any) => Promise<wechat.SendWxaTemplateRes>} TypeScript syntax */

export function SendWxaTemplate(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendWxaTemplate",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.GetWxaCustomMessageResponderReq, b: any) => Promise<wechat.GetWxaCustomMessageResponderRes>} TypeScript syntax */

export function GetWxaCustomMessageResponder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaCustomMessageResponder",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.SetWxaCustomMessageResponderReq, b: any) => Promise<wechat.SetWxaCustomMessageResponderRes>} TypeScript syntax */

export function SetWxaCustomMessageResponder(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SetWxaCustomMessageResponder",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.SendWxaCustomMessageReq, b: any) => Promise<wechat.SendWxaCustomMessageRes>} TypeScript syntax */

export function SendWxaCustomMessage(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendWxaCustomMessage",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// ErrUnknownAuthType 未知的authType

/** @type {(r: wechat.GetWeanAlysisAppidDailyVisitTrendReq, b: any) => Promise<wechat.GetWeanAlysisAppidDailyVisitTrendRes>} TypeScript syntax */

export function GetWeanAlysisAppidDailyVisitTrend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWeanAlysisAppidDailyVisitTrend",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// ErrUnknownAuthType 未知的authType

/** @type {(r: wechat.SendTemplateMsgReq, b: any) => Promise<wechat.SendTemplateMsgRsp>} TypeScript syntax */

export function SendTemplateMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendTemplateMsg",
    "auth": "1"
  }), o));
}
;
/** @type {(r: wechat.ReportFormIdReq, b: any) => Promise<wechat.ReportFormIdRsp>} TypeScript syntax */

export function ReportFormId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/ReportFormId",
    "auth": "1"
  }), o));
}
; // @desc: 生成登陆二维码的的url
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.GenWxwLoginUrlReq, b: any) => Promise<wechat.GenWxwLoginUrlRsp>} TypeScript syntax */

export function GenWxwLoginUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GenWxwLoginUrl",
    "auth": "1"
  }), o));
}
; // @error:
// ErrNotFoundWxwConf
// @desc: 生成使用js内嵌方式登陆的配置
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.GenWxwLoginConfReq, b: any) => Promise<wechat.GenWxwLoginConfRsp>} TypeScript syntax */

export function GenWxwLoginConf(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GenWxwLoginConf",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// ErrNotFoundWxwConf
// @desc: 根据前端传入的code获取用户的open_id以及union_id
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.GetWxwUnionIdByCodeRep, b: any) => Promise<wechat.GetWxwUnionIdByCodeRsp>} TypeScript syntax */

export function GetWxwUnionIdByCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxwUnionIdByCode",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.WxaMediaCheckAsyncReq, b: any) => Promise<wechat.WxaMediaCheckAsyncRsp>} TypeScript syntax */

export function WxaMediaCheckAsync(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/WxaMediaCheckAsync",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// @name: 获取用户信息
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.GetWxwUserInfoReq, b: any) => Promise<wechat.GetWxwUserInfoRsp>} TypeScript syntax */

export function GetWxwUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxwUserInfo",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// @name: 获取accessToken
// @gen_to: tokenimpl

/** @type {(r: wechat.GetAccessTokenReq, b: any) => Promise<wechat.GetAccessTokenRsp>} TypeScript syntax */

export function GetAccessToken(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetAccessToken",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAppType 未知的appType
// ErrRequireComponentKey componentKey不能为空
// ErrRequireAppId appId不能为空
// ErrRequireAppIdAndComponentKey appId和componentKey不能为空
// @name: 刷新AccessToken
// @gen_to: tokenimpl

/** @type {(r: wechat.ExpireAccessTokenReq, b: any) => Promise<wechat.ExpireAccessTokenRsp>} TypeScript syntax */

export function ExpireAccessToken(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/ExpireAccessToken",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrUnknownMetaRole 未知的rpc.Meta.Role
// ErrMpComponentNotFound 第三方平台不存在
// ErrProcessingAuditExists 存在审核中的记录
// ErrInvalidRequest 无效的请求
// ErrCodeTemplateIsEmpty 代码模版为空
// ErrAppNotAuth 小程序未授权
// @name: 授权事件、component_verify_ticket推送
// @gen_to: authimpl
// svr options: (ext.UserType) = pub

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function AuthNotify(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AuthNotify",
    "auth": "0"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// ErrInvalidRequest 无效的请求
// ErrMpComponentNotFound 第三方平台不存在
// @name: 获取授权链接
// @gen_to: open

/** @type {(r: wechat.GetAuthUrlReq, b: any) => Promise<wechat.GetAuthUrlRsp>} TypeScript syntax */

export function GetAuthUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetAuthUrl",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechatAlreadyAuthorize 该公众号已授权至其他企业
// ErrWechat 系统错误
// ErrInvalidRequest 无效的请求
// ErrMpComponentNotFound 第三方平台不存在
// @name: 授权
// @gen_to: open

/** @type {(r: wechat.AuthorizedReq, b: any) => Promise<wechat.MpComponentGetAuthAppInfoRsp>} TypeScript syntax */

export function Authorized(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/Authorized",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 初始化第三方平台信息
// @gen_to: initimpl

/** @type {(r: wechat.InitComponentReq, b: any) => Promise<wechat.InitComponentRsp>} TypeScript syntax */

export function InitComponent(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/InitComponent",
    "auth": "1"
  }), o));
}
; // @name: 初始化wxapp配置信息
// @desc: 供wxtoken调用，把application_instance中的数据解析过来
// @gen_to: initimpl

/** @type {(r: wechat.InitWxAppConfigReq, b: any) => Promise<wechat.InitWxAppConfigRsp>} TypeScript syntax */

export function InitWxAppConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/InitWxAppConfig",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 添加小程序服务器域名
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentAddServerDomainReq, b: any) => Promise<wechat.MpComponentAddServerDomainRsp>} TypeScript syntax */

export function MpComponentAddServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentAddServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 查询小程序服务器域名
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetServerDomainReq, b: any) => Promise<wechat.MpComponentGetServerDomainRsp>} TypeScript syntax */

export function MpComponentGetServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 删除小程序服务器域名
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentDelServerDomainReq, b: any) => Promise<wechat.MpComponentDelServerDomainRsp>} TypeScript syntax */

export function MpComponentDelServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentDelServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 添加小程序业务域名
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentAddBizServerDomainReq, b: any) => Promise<wechat.MpComponentAddBizServerDomainRsp>} TypeScript syntax */

export function MpComponentAddBizServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentAddBizServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 查询小程序业务域名
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetBizServerDomainReq, b: any) => Promise<wechat.MpComponentGetBizServerDomainRsp>} TypeScript syntax */

export function MpComponentGetBizServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetBizServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 删除小程序业务域名
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentDelBizServerDomainReq, b: any) => Promise<wechat.MpComponentDelBizServerDomainRsp>} TypeScript syntax */

export function MpComponentDelBizServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentDelBizServerDomain",
    "auth": "1"
  }), o));
}
; // @desc: https://developers.weixin.qq.com/doc/oplatform/Third-party_Platforms/2.0/api/category/getcategory.html
// @name: 获取已设置的所有类目
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetCategoryReq, b: any) => Promise<wechat.MpComponentGetCategoryRsp>} TypeScript syntax */

export function MpComponentGetCategory(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetCategory",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrUnknownMetaRole 未知的rpc.Meta.Role
// ErrInvalidRequest 无效的请求
// ErrProcessingAuditExists 存在审核中的记录
// ErrCodeTemplateIsEmpty 代码模版为空
// ErrAppNotAuth 小程序未授权
// @name: 上传代码
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentUploadCodesAndSubmitAuditReq, b: any) => Promise<wechat.MpComponentUploadCodesAndSubmitAuditRsp>} TypeScript syntax */

export function MpComponentUploadCodesAndSubmitAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentUploadCodesAndSubmitAudit",
    "auth": "1"
  }), o));
}
; // @name: 提交审核
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentSubmitAuditReq, b: any) => Promise<wechat.MpComponentSubmitAuditRsp>} TypeScript syntax */

export function MpComponentSubmitAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentSubmitAudit",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrMpComponentNotFound 第三方平台不存在
// @name: 消息与事件推送（包括审核结果）
// @gen_to: authimpl
// svr options: (ext.UserType) = pub
// svr options: (ext.Url) = /wechat/msgEvent/:componentKey/:appId/notify

/** @type {(r: ext.RawReq, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function MpComponentMsgNotify(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentMsgNotify",
    "auth": "0"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 查询代码审核状态
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetAuditStatusReq, b: any) => Promise<wechat.MpComponentGetAuditStatusRsp>} TypeScript syntax */

export function MpComponentGetAuditStatus(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetAuditStatus",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 发布
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentReleaseReq, b: any) => Promise<wechat.MpComponentReleaseRsp>} TypeScript syntax */

export function MpComponentRelease(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentRelease",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 灰度发布
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGrayReleaseReq, b: any) => Promise<wechat.MpComponentGrayReleaseRsp>} TypeScript syntax */

export function MpComponentGrayRelease(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGrayRelease",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 查询灰度发布的情况
// @desc:
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetGrayReleasePlanReq, b: any) => Promise<wechat.MpComponentGetGrayReleasePlanRsp>} TypeScript syntax */

export function MpComponentGetGrayReleasePlan(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetGrayReleasePlan",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 回滚灰度发布
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentRevertGrayReleaseReq, b: any) => Promise<wechat.MpComponentRevertGrayReleaseRsp>} TypeScript syntax */

export function MpComponentRevertGrayRelease(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentRevertGrayRelease",
    "auth": "1"
  }), o));
}
; // @error:
// ErrMpComponentNotFound 第三方平台不存在
// @name: 取消授权
// @gen_to: authimpl

/** @type {(r: wechat.MpComponentCancelAuthReq, b: any) => Promise<wechat.MpComponentCancelAuthRsp>} TypeScript syntax */

export function MpComponentCancelAuth(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentCancelAuth",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 覆盖设置小程序服务器域名
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentSetServerDomainReq, b: any) => Promise<wechat.MpComponentSetServerDomainRsp>} TypeScript syntax */

export function MpComponentSetServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentSetServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 覆盖设置小程序业务域名
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentSetBizServerDomainReq, b: any) => Promise<wechat.MpComponentSetBizServerDomainRsp>} TypeScript syntax */

export function MpComponentSetBizServerDomain(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentSetBizServerDomain",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrAppNotAuth 小程序未授权
// @name: 添加小程序体验者
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentAddTesterReq, b: any) => Promise<wechat.MpComponentAddTesterRsp>} TypeScript syntax */

export function MpComponentAddTester(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentAddTester",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @name: 删除小程序体验者
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentDelTesterReq, b: any) => Promise<wechat.MpComponentDelTesterRsp>} TypeScript syntax */

export function MpComponentDelTester(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentDelTester",
    "auth": "1"
  }), o));
}
; // @error:
// ErrAppNotAuth 小程序未授权
// @name: 查询小程序体验者列表
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetTesterListReq, b: any) => Promise<wechat.MpComponentGetTesterListRsp>} TypeScript syntax */

export function MpComponentGetTesterList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetTesterList",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrInvalidRequest 无效的请求
// ErrMpComponentNotFound 第三方平台不存在
// ErrAppNotAuth 小程序未授权
// @name: 获取小程序信息
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetAuthAppInfoReq, b: any) => Promise<wechat.MpComponentGetAuthAppInfoRsp>} TypeScript syntax */

export function MpComponentGetAuthAppInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetAuthAppInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 检查一段文本是否含有违法违规内容
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrRiskyContent 含有违法违规内容

/** @type {(r: wechat.MsgSecCheckReq, b: any) => Promise<wechat.MsgSecCheckRsp>} TypeScript syntax */

export function MsgSecCheck(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MsgSecCheck",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 检查一张图片是否含有违法违规内容
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.ImgSecCheckReq, b: any) => Promise<wechat.ImgSecCheckRsp>} TypeScript syntax */

export function ImgSecCheck(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/ImgSecCheck",
    "auth": "1"
  }), o));
}
; // @cat: 公众号
// @name:获取公众号公众号网页授权access_token
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrNotOfficialApp 非公众号
// @gen_to: officialaccount

/** @type {(r: wechat.OfficialGetAccessTokenReq, b: any) => Promise<wechat.OfficialGetAccessTokenRsp>} TypeScript syntax */

export function OfficialGetAccessToken(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/OfficialGetAccessToken",
    "auth": "1"
  }), o));
}
; // @cat: 公众号
// @name: 获取公众号JS-SDK所需配置
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// ErrNotOfficialApp 非公众号
// @gen_to: officialaccount

/** @type {(r: wechat.OfficialGetJsSdkConfigReq, b: any) => Promise<wechat.OfficialGetJsSdkConfigRsp>} TypeScript syntax */

export function OfficialGetJsSdkConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/OfficialGetJsSdkConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 根据wxAppId获取AccessToken（目前只支持authType=nonAuth的情况）
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// @gen_to: tokenimpl

/** @type {(r: wechat.GetAccessTokenByWxAppIdReq, b: any) => Promise<wechat.GetAccessTokenRsp>} TypeScript syntax */

export function GetAccessTokenByWxAppId(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetAccessTokenByWxAppId",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 撒回小程序审核
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentCancelAuditReq, b: any) => Promise<wechat.WXHeader>} TypeScript syntax */

export function MpComponentCancelAudit(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentCancelAudit",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取已上传的代码的页面列表
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetUploadedPageListReq, b: any) => Promise<wechat.MpComponentGetUploadedPageListRsp>} TypeScript syntax */

export function MpComponentGetUploadedPageList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetUploadedPageList",
    "auth": "1"
  }), o));
}
; // @name: 查询最新一次提交的审核状态
// @link: https://developers.weixin.qq.com/doc/oplatform/Third-party_Platforms/2.0/api/code/get_latest_auditstatus.html
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetLatestAuditStatusReq, b: any) => Promise<wechat.MpComponentGetLatestAuditStatusRsp>} TypeScript syntax */

export function MpComponentGetLatestAuditStatus(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetLatestAuditStatus",
    "auth": "1"
  }), o));
}
; // @cat: 微信广告
// @name: 创建数据源
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.AdAddUserActionSetReq, b: any) => Promise<wechat.AdAddUserActionSetRsp>} TypeScript syntax */

export function AdAddUserActionSet(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AdAddUserActionSet",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.AdAddUserActionReq, b: any) => Promise<wechat.AdAddUserActionRsp>} TypeScript syntax */

export function AdAddUserAction(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AdAddUserAction",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.AdGetUserActionSetReportReq, b: any) => Promise<wechat.AdGetUserActionSetReportRsp>} TypeScript syntax */

export function AdGetUserActionSetReport(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AdGetUserActionSetReport",
    "auth": "1"
  }), o));
}
; // @cat:
// @name: 获取小程序体验版的二维码url
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// @gen_to: settingimpl

/** @type {(r: wechat.MpComponentGetTestAppQrCodeUrlReq, b: any) => Promise<wechat.MpComponentGetTestAppQrCodeUrlRsp>} TypeScript syntax */

export function MpComponentGetTestAppQrCodeUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/MpComponentGetTestAppQrCodeUrl",
    "auth": "1"
  }), o));
}
; // @cat: 数据分析
// @name: 获取用户小程序访问分布数据
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.GetVisitDistributionReq, b: any) => Promise<wechat.GetVisitDistributionRsp>} TypeScript syntax */

export function GetVisitDistribution(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetVisitDistribution",
    "auth": "1"
  }), o));
}
; // @cat: 数据分析
// @name: 访问页面。目前只提供按 page_visit_pv 排序的 top200。
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.GetVisitPageReq, b: any) => Promise<wechat.GetVisitPageRsp>} TypeScript syntax */

export function GetVisitPage(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetVisitPage",
    "auth": "1"
  }), o));
}
; // @cat: 数据分析
// @name: 访问趋势(daily)
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.GetVisitTrendReq, b: any) => Promise<wechat.GetVisitTrendRsp>} TypeScript syntax */

export function GetVisitTrend(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetVisitTrend",
    "auth": "1"
  }), o));
}
; // @cat: 订阅消息
// @name: 发送订阅消息
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.SendSubscribeMessageReq, b: any) => Promise<wechat.SendSubscribeMessageRsp>} TypeScript syntax */

export function SendSubscribeMessage(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendSubscribeMessage",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAccessTokenNotFound
// ErrWechat 系统错误
// @gen_to: officialaccount

/** @type {(r: wechat.GetOfficialAccountTemporaryQrCodeReq, b: any) => Promise<wechat.GetOfficialAccountTemporaryQrCodeRsp>} TypeScript syntax */

export function GetOfficialAccountTemporaryQrCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetOfficialAccountTemporaryQrCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrAccessTokenNotFound
// ErrWechat 系统错误
// @gen_to: officialaccount

/** @type {(r: wechat.GetOfficialAccountPermanentQrCodeReq, b: any) => Promise<wechat.GetOfficialAccountPermanentQrCodeRsp>} TypeScript syntax */

export function GetOfficialAccountPermanentQrCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetOfficialAccountPermanentQrCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @gen_to: officialaccount

/** @type {(r: wechat.SendOfficialAccountTemplateMsgReq, b: any) => Promise<wechat.SendOfficialAccountTemplateMsgRsp>} TypeScript syntax */

export function SendOfficialAccountTemplateMsg(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendOfficialAccountTemplateMsg",
    "auth": "1"
  }), o));
}
; // @cat: 公众号
// @name: 获取公众号已经关注的用户的个人信息
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @gen_to: officialaccount

/** @type {(r: wechat.GetUserInfoReq, b: any) => Promise<wechat.GetUserInfoRsp>} TypeScript syntax */

export function GetUserInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetUserInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrEncryptFailure 加密失败
// ErrDecryptFailure 解密失败
// @gen_to: officialaccount

/** @type {(r: wechat.ReceiveOfficialAccountEventV2Req, b: any) => Promise<ext.RawRsp>} TypeScript syntax */

export function ReceiveOfficialAccountEventV2(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/ReceiveOfficialAccountEventV2",
    "auth": "1"
  }), o));
}
; // @error:
// ErrWechat 系统错误
// @desc: 根据前端传入的code获取用户的open_id以及union_id
// svr options: (ext.Flags) = 2

/** @type {(r: wechat.GetWxwUnionIdByCodeWithWxConfRep, b: any) => Promise<wechat.GetWxwUnionIdByCodeRsp>} TypeScript syntax */

export function GetWxwUnionIdByCodeWithWxConf(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxwUnionIdByCodeWithWxConf",
    "auth": "1"
  }), o));
}
; // @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误
// @desc: 创建微信菜单
// @gen_to: officialaccount

/** @type {(r: wechat.CreateWxMenuRep, b: any) => Promise<wechat.CreateWxMenuRsp>} TypeScript syntax */

export function CreateWxMenu(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/CreateWxMenu",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.GetDailySummaryReq, b: any) => Promise<wechat.GetDailySummaryRsp>} TypeScript syntax */

export function GetDailySummary(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetDailySummary",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrUnknownAuthType 未知的authType
// ErrWechat 系统错误

/** @type {(r: wechat.GetUserPortraitReq, b: any) => Promise<wechat.GetUserPortraitRsp>} TypeScript syntax */

export function GetUserPortrait(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetUserPortrait",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrInvalidRequest 无效的请求
// ErrWechat 系统错误
// @gen_to: open

/** @type {(r: wechat.PushTicketReq, b: any) => Promise<wechat.PushTicketRsp>} TypeScript syntax */

export function PushTicket(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/PushTicket",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMpComponentNotFound 第三方平台不存在
// ErrWechat 系统错误
// ErrInvalidRequest 无效的请求
// @gen_to: open

/** @type {(r: wechat.CreateOpenReq, b: any) => Promise<wechat.CreateOpenRsp>} TypeScript syntax */

export function CreateOpen(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/CreateOpen",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrWechat 系统错误
// ErrInvalidRequest 无效的请求
// ErrMpComponentNotFound 第三方平台不存在
// @gen_to: oauth

/** @type {(r: wechat.GetOauthTokenByCodeReq, b: any) => Promise<wechat.GetOauthTokenByCodeRsp>} TypeScript syntax */

export function GetOauthTokenByCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetOauthTokenByCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: app

/** @type {(r: wechat.GetNewWxAppConfigReq, b: any) => Promise<wechat.GetNewWxAppConfigRsp>} TypeScript syntax */

export function GetNewWxAppConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetNewWxAppConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrMpComponentNotFound 第三方平台不存在
// @gen_to: oauth
// svr options: (ext.UserType) = pub

/** @type {(r: wechat.GetOauthUrlReq, b: any) => Promise<wechat.GetOauthUrlRsp>} TypeScript syntax */

export function GetOauthUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetOauthUrl",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: oauth

/** @type {(r: wechat.GetOauthInfoReq, b: any) => Promise<wechat.GetOauthInfoRsp>} TypeScript syntax */

export function GetOauthInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetOauthInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=add_model_db_proxy;m=ModelPayConfig
// @gen_to: pay

/** @type {(r: wechat.AddPayConfigReq, b: any) => Promise<wechat.AddPayConfigRsp>} TypeScript syntax */

export function AddPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AddPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=del_model_db_proxy;m=ModelPayConfig
// @gen_to: pay

/** @type {(r: wechat.DelPayConfigReq, b: any) => Promise<wechat.DelPayConfigRsp>} TypeScript syntax */

export function DelPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/DelPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=set_model_db_proxy;m=ModelPayConfig
// @gen_to: pay

/** @type {(r: wechat.SetPayConfigReq, b: any) => Promise<wechat.SetPayConfigRsp>} TypeScript syntax */

export function SetPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SetPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx;m=ModelPayConfig
// @gen_to: pay

/** @type {(r: wechat.GetPayConfigListReq, b: any) => Promise<wechat.GetPayConfigListRsp>} TypeScript syntax */

export function GetPayConfigList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetPayConfigList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: pay

/** @type {(r: wechat.TransferReq, b: any) => Promise<wechat.TransferRsp>} TypeScript syntax */

export function Transfer(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/Transfer",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_dbx;m=ModelWxAuthorizer
// @gen_to: authorizer

/** @type {(r: wechat.GetWxAuthorizerListReq, b: any) => Promise<wechat.GetWxAuthorizerListRsp>} TypeScript syntax */

export function GetWxAuthorizerList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxAuthorizerList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: pay

/** @type {(r: wechat.AuthorizerBindMchReq, b: any) => Promise<wechat.AuthorizerBindMchRsp>} TypeScript syntax */

export function AuthorizerBindMch(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AuthorizerBindMch",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelWxAuthorizer
// @gen_to: authorizer

/** @type {(r: wechat.GetWxAuthorizerReq, b: any) => Promise<wechat.GetWxAuthorizerRsp>} TypeScript syntax */

export function GetWxAuthorizer(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxAuthorizer",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_db_proxy;m=ModelPayConfig
// @gen_to: pay

/** @type {(r: wechat.GetPayConfigReq, b: any) => Promise<wechat.GetPayConfigRsp>} TypeScript syntax */

export function GetPayConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetPayConfig",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: wechat.GetUserByOpenidReq, b: any) => Promise<wechat.GetUserByOpenidRsp>} TypeScript syntax */

export function GetUserByOpenid(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetUserByOpenid",
    "auth": "1"
  }), o));
}
; // @error:
// ossreport.ErrInvalidRequestData invalid request data

/** @type {(r: wechat.GetWxaSession4OauthReq, b: any) => Promise<wechat.GetWxaSession4OauthRes>} TypeScript syntax */

export function GetWxaSession4Oauth(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSession4Oauth",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrNotOfficialApp 非公众号
// @gen_to: jssdk
// svr options: (ext.UserType) = pub

/** @type {(r: wechat.BuildConfigReq, b: any) => Promise<wechat.BuildConfigRsp>} TypeScript syntax */

export function BuildConfig(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/BuildConfig",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc: 提供给其他环境调用的获取小程序token的接口，通过hash简单校验
// @error:
// @gen_to: token
// svr options: (ext.UserType) = pub

/** @type {(r: wechat.GetAccessTokenForTestReq, b: any) => Promise<wechat.GetAccessTokenRsp>} TypeScript syntax */

export function GetAccessTokenForTest(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetAccessTokenForTest",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.GetWechatUserByWxaCodeReq, b: any) => Promise<wechat.GetWechatUserByWxaCodeRsp>} TypeScript syntax */

export function GetWechatUserByWxaCode(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWechatUserByWxaCode",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: wechat.UpdateWxUserReq, b: any) => Promise<wechat.UpdateWxUserRsp>} TypeScript syntax */

export function UpdateWxUser(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/UpdateWxUser",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.AddWxaSubscribeTemplateReq, b: any) => Promise<wechat.AddWxaSubscribeTemplateRsp>} TypeScript syntax */

export function AddWxaSubscribeTemplate(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/AddWxaSubscribeTemplate",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.SendWxaSubscribeTemplateReq, b: any) => Promise<wechat.SendWxaSubscribeTemplateRsp>} TypeScript syntax */

export function SendWxaSubscribeTemplate(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SendWxaSubscribeTemplate",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.GetWxaSubscribeTemplateCategoryListReq, b: any) => Promise<wechat.GetWxaSubscribeTemplateCategoryListRsp>} TypeScript syntax */

export function GetWxaSubscribeTemplateCategoryList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSubscribeTemplateCategoryList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.GetWxaSubscribeTemplateTitleListReq, b: any) => Promise<wechat.GetWxaSubscribeTemplateTitleListRsp>} TypeScript syntax */

export function GetWxaSubscribeTemplateTitleList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSubscribeTemplateTitleList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.GetWxaSubscribeTemplateListReq, b: any) => Promise<wechat.GetWxaSubscribeTemplateListRsp>} TypeScript syntax */

export function GetWxaSubscribeTemplateList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSubscribeTemplateList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:

/** @type {(r: wechat.GetWxaSubscribeTemplateKeywordListReq, b: any) => Promise<wechat.GetWxaSubscribeTemplateKeywordListRsp>} TypeScript syntax */

export function GetWxaSubscribeTemplateKeywordList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/GetWxaSubscribeTemplateKeywordList",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen_to: user

/** @type {(r: wechat.SetUserPhoneReq, b: any) => Promise<wechat.SetUserPhoneRsp>} TypeScript syntax */

export function SetUserPhone(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/wechat/SetUserPhone",
    "auth": "1"
  }), o));
}
;
var WechatServices = {
  GetWxaSession: GetWxaSession,
  GetWxaUserInfo: GetWxaUserInfo,
  GetWxaPhoneNumber: GetWxaPhoneNumber,
  EncodeWxaScene: EncodeWxaScene,
  DecodeWxaScene: DecodeWxaScene,
  GetWxaCodeUnlimit: GetWxaCodeUnlimit,
  CreateWxaQrcode: CreateWxaQrcode,
  AddWxaFormId: AddWxaFormId,
  DecodeEncryptedData: DecodeEncryptedData,
  SendWxaTemplate: SendWxaTemplate,
  GetWxaCustomMessageResponder: GetWxaCustomMessageResponder,
  SetWxaCustomMessageResponder: SetWxaCustomMessageResponder,
  SendWxaCustomMessage: SendWxaCustomMessage,
  GetWeanAlysisAppidDailyVisitTrend: GetWeanAlysisAppidDailyVisitTrend,
  SendTemplateMsg: SendTemplateMsg,
  ReportFormId: ReportFormId,
  GenWxwLoginUrl: GenWxwLoginUrl,
  GenWxwLoginConf: GenWxwLoginConf,
  GetWxwUnionIdByCode: GetWxwUnionIdByCode,
  WxaMediaCheckAsync: WxaMediaCheckAsync,
  GetWxwUserInfo: GetWxwUserInfo,
  GetAccessToken: GetAccessToken,
  ExpireAccessToken: ExpireAccessToken,
  AuthNotify: AuthNotify,
  GetAuthUrl: GetAuthUrl,
  Authorized: Authorized,
  InitComponent: InitComponent,
  InitWxAppConfig: InitWxAppConfig,
  MpComponentAddServerDomain: MpComponentAddServerDomain,
  MpComponentGetServerDomain: MpComponentGetServerDomain,
  MpComponentDelServerDomain: MpComponentDelServerDomain,
  MpComponentAddBizServerDomain: MpComponentAddBizServerDomain,
  MpComponentGetBizServerDomain: MpComponentGetBizServerDomain,
  MpComponentDelBizServerDomain: MpComponentDelBizServerDomain,
  MpComponentGetCategory: MpComponentGetCategory,
  MpComponentUploadCodesAndSubmitAudit: MpComponentUploadCodesAndSubmitAudit,
  MpComponentSubmitAudit: MpComponentSubmitAudit,
  MpComponentMsgNotify: MpComponentMsgNotify,
  MpComponentGetAuditStatus: MpComponentGetAuditStatus,
  MpComponentRelease: MpComponentRelease,
  MpComponentGrayRelease: MpComponentGrayRelease,
  MpComponentGetGrayReleasePlan: MpComponentGetGrayReleasePlan,
  MpComponentRevertGrayRelease: MpComponentRevertGrayRelease,
  MpComponentCancelAuth: MpComponentCancelAuth,
  MpComponentSetServerDomain: MpComponentSetServerDomain,
  MpComponentSetBizServerDomain: MpComponentSetBizServerDomain,
  MpComponentAddTester: MpComponentAddTester,
  MpComponentDelTester: MpComponentDelTester,
  MpComponentGetTesterList: MpComponentGetTesterList,
  MpComponentGetAuthAppInfo: MpComponentGetAuthAppInfo,
  MsgSecCheck: MsgSecCheck,
  ImgSecCheck: ImgSecCheck,
  OfficialGetAccessToken: OfficialGetAccessToken,
  OfficialGetJsSdkConfig: OfficialGetJsSdkConfig,
  GetAccessTokenByWxAppId: GetAccessTokenByWxAppId,
  MpComponentCancelAudit: MpComponentCancelAudit,
  MpComponentGetUploadedPageList: MpComponentGetUploadedPageList,
  MpComponentGetLatestAuditStatus: MpComponentGetLatestAuditStatus,
  AdAddUserActionSet: AdAddUserActionSet,
  AdAddUserAction: AdAddUserAction,
  AdGetUserActionSetReport: AdGetUserActionSetReport,
  MpComponentGetTestAppQrCodeUrl: MpComponentGetTestAppQrCodeUrl,
  GetVisitDistribution: GetVisitDistribution,
  GetVisitPage: GetVisitPage,
  GetVisitTrend: GetVisitTrend,
  SendSubscribeMessage: SendSubscribeMessage,
  GetOfficialAccountTemporaryQrCode: GetOfficialAccountTemporaryQrCode,
  GetOfficialAccountPermanentQrCode: GetOfficialAccountPermanentQrCode,
  SendOfficialAccountTemplateMsg: SendOfficialAccountTemplateMsg,
  GetUserInfo: GetUserInfo,
  ReceiveOfficialAccountEventV2: ReceiveOfficialAccountEventV2,
  GetWxwUnionIdByCodeWithWxConf: GetWxwUnionIdByCodeWithWxConf,
  CreateWxMenu: CreateWxMenu,
  GetDailySummary: GetDailySummary,
  GetUserPortrait: GetUserPortrait,
  PushTicket: PushTicket,
  CreateOpen: CreateOpen,
  GetOauthTokenByCode: GetOauthTokenByCode,
  GetNewWxAppConfig: GetNewWxAppConfig,
  GetOauthUrl: GetOauthUrl,
  GetOauthInfo: GetOauthInfo,
  AddPayConfig: AddPayConfig,
  DelPayConfig: DelPayConfig,
  SetPayConfig: SetPayConfig,
  GetPayConfigList: GetPayConfigList,
  Transfer: Transfer,
  GetWxAuthorizerList: GetWxAuthorizerList,
  AuthorizerBindMch: AuthorizerBindMch,
  GetWxAuthorizer: GetWxAuthorizer,
  GetPayConfig: GetPayConfig,
  GetUserByOpenid: GetUserByOpenid,
  GetWxaSession4Oauth: GetWxaSession4Oauth,
  BuildConfig: BuildConfig,
  GetAccessTokenForTest: GetAccessTokenForTest,
  GetWechatUserByWxaCode: GetWechatUserByWxaCode,
  UpdateWxUser: UpdateWxUser,
  AddWxaSubscribeTemplate: AddWxaSubscribeTemplate,
  SendWxaSubscribeTemplate: SendWxaSubscribeTemplate,
  GetWxaSubscribeTemplateCategoryList: GetWxaSubscribeTemplateCategoryList,
  GetWxaSubscribeTemplateTitleList: GetWxaSubscribeTemplateTitleList,
  GetWxaSubscribeTemplateList: GetWxaSubscribeTemplateList,
  GetWxaSubscribeTemplateKeywordList: GetWxaSubscribeTemplateKeywordList,
  SetUserPhone: SetUserPhone
};
export default WechatServices;